import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import ProjectCard from "./ProjectCard";

const ProjectList = ({ projects, ...props }) => {
  if (!projects || projects.length === 0) {
    return (
      <Typography
        variant="h6"
        color="text.secondary"
        align="center"
        sx={{ mt: 4 }}
      >
        No projects found
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          sm: "1fr 1fr",
          md: "1fr 1fr",
          lg: "1fr 1fr",
        },
        gap: 3,
      }}
    >
      {projects.map((project) => (
        <Grid item xs={12} sm={6} key={project._id}>
          <ProjectCard project={project} {...props} />
        </Grid>
      ))}
    </Box>
  );
};

export default ProjectList;
